type FilterData = {
  includes?: string[];
  excludes?: string[];
  min?: number;
  max?: number;
  fromDate?: string;
  toDate?: string;
  [key: string]: any;
};

type Filter = {
  filterKey: string;
  filterName: string;
  filterData: FilterData;
};

type InputFilters = {
  [key: string]: Filter;
};

type OutputFilter = {
  filterName: string;
  filterGroup: string | null;
  includes?: string[];
  excludes?: string[];
  min?: string | number | null;
  max?: string | number | null;
  fromDate?: string;
  toDate?: string;
  range?: any;
  ranges?: any;
  domain?: string;
  excludePageSearch?: boolean;
};

export function parseFiltersForPlaybook(filters: InputFilters): OutputFilter[] {
  console.log('filters', filters);
  const result: OutputFilter[] = [];

  for (const filterKey in filters) {
    if (filters.hasOwnProperty(filterKey)) {
      const filter = filters[filterKey];
      const filterData = filter.filterData;
      const outputFilter: OutputFilter = {
        filterName: filter.filterName,
        filterGroup: null,
      };

      // Check if filterData contains direct values (includes, excludes, min, max, fromDate, toDate)
      const hasDirectValues = Object.keys(filterData).some((key) =>
        ['includes', 'excludes', 'min', 'max', 'fromDate', 'toDate', 'range', 'ranges'].includes(
          key,
        ),
      );

      if (hasDirectValues) {
        // Add direct values to the output filter
        if ('includes' in filterData) {
          outputFilter.includes = filterData.includes;
        }
        if ('excludes' in filterData) {
          outputFilter.excludes = filterData.excludes;
        }
        if ('min' in filterData) {
          outputFilter.min = filterData.min;
        }
        if ('max' in filterData) {
          outputFilter.max = filterData.max;
        }
        if ('fromDate' in filterData) {
          outputFilter.fromDate = filterData.fromDate;
        }
        if ('toDate' in filterData) {
          outputFilter.toDate = filterData.toDate;
        }
        if ('range' in filterData) {
          outputFilter.ranges = filterData.range;
        }
        result.push(outputFilter);
      } else {
        // Process nested filters
        for (const key in filterData) {
          if (filterData.hasOwnProperty(key)) {
            const nestedData = filterData[key];
            const nestedFilter: OutputFilter = {
              filterName: key,
              filterGroup: filter.filterName,
            };

            if ('includes' in nestedData) {
              nestedFilter.includes = nestedData.includes;
            }
            if ('excludes' in nestedData) {
              nestedFilter.excludes = nestedData.excludes;
            }
            if ('min' in nestedData) {
              nestedFilter.min = nestedData.min;
            }
            if ('max' in nestedData) {
              nestedFilter.max = nestedData.max;
            }
            if ('fromDate' in nestedData) {
              nestedFilter.fromDate = nestedData.fromDate;
            }
            if ('toDate' in nestedData) {
              nestedFilter.toDate = nestedData.toDate;
            }
            if ('range' in nestedData) {
              nestedFilter.ranges = nestedData.range;
            }
            if ('ranges' in nestedData) {
              nestedFilter.ranges = nestedData.range;
            }
            if ('domain' in nestedData) {
              nestedFilter.domain = nestedData.domain;
            }
            if ('excludePageSearch' in nestedData) {
              nestedFilter.excludePageSearch = nestedData.excludePageSearch;
            }
            result.push(nestedFilter);
          }
        }
      }
    }
  }

  const filteredResult = filterObjects(result);
  return filteredResult;
}

function filterObjects(arr: OutputFilter[]): OutputFilter[] {
  return arr.filter((obj) => {
    if (
      obj.hasOwnProperty('min') &&
      obj.hasOwnProperty('max') &&
      obj.hasOwnProperty('range') &&
      obj.hasOwnProperty('ranges')
    ) {
      return (
        !(obj.min == null || obj.min === '') ||
        !(obj.max == null || obj.max === '') ||
        !(obj.range == null || obj.range.length === 0) ||
        !(obj.ranges == null || obj.ranges.length === 0)
      );
    }
    return true;
  });
}
